export default [
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/auth/Status404.vue'),
    meta: {},
  },
];
